// NOTE: Core bundle needs to be imported first
import './core-bundle/init';
// some components use i18n in the defaultProps which are evaluated
// at require time (so when we require Layout). This still has to
// be required before anything else
import './init/locale';

import ReactDOM from 'react-dom';
import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';

import { initScripts, initRouting, initLaunchDarkly } from './init';

import Store from '@app/store';
import Layout from '@component/layout';

const rootNode = document.querySelector('.root-node');

const App = ({ route, language }) => {
  React.useEffect(initScripts, []);
  return <Layout route={route} language={language} />;
};

App.propTypes = {
  route: PropTypes.object,
  language: PropTypes.string,
};

// Subscribe to our Redux stores
Store.subscribe(() => {
  const { route, session } = Store.getState();
  ReactDOM.render(
    <Provider store={Store}>
      <App route={route} language={session.language} />
    </Provider>,
    rootNode
  );
});

// init/routing.js conditionally adds routes based on launch darkly feature flags
initLaunchDarkly();
// the router expects the Store.subscribe to be called before initialising it
initRouting();
